
export default function Bio() {
  const services = [
    {
      icon: 'ri-video-line',
      title: 'UGC Videos',
      description: 'Authentic product demos, reviews, unboxings & testimonials that convert',
      deliverables: ['15-60 sec videos', 'Raw footage included', 'Hooks & CTAs']
    },
    {
      icon: 'ri-camera-line',
      title: 'Photo Content',
      description: 'Lifestyle photography & product shots for ads, social & web',
      deliverables: ['High-res images', 'Multiple angles', 'Lifestyle & flat lay']
    },
    {
      icon: 'ri-instagram-line',
      title: 'Social Posts',
      description: 'Ready-to-post content optimized for TikTok, Reels & Stories',
      deliverables: ['Platform optimized', 'Captions included', 'Trending formats']
    }
  ];

  return (
    <section id="about" className="py-16 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        {/* About Me */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center mb-16 md:mb-24">
          <div className="relative">
            <div className="w-full aspect-square rounded-2xl md:rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20female%20content%20creator%20portrait%20smiling%20confidently%20with%20camera%20equipment%20in%20background%20bright%20modern%20studio%20setting%20warm%20natural%20lighting%20wearing%20casual%20chic%20outfit%20authentic%20friendly%20expression&width=500&height=500&seq=about1&orientation=squarish"
                alt="Sarah - UGC Creator"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-6 bg-amber-100 rounded-xl md:rounded-2xl p-4 md:p-6">
              <div className="text-2xl md:text-3xl font-bold text-stone-900">3+</div>
              <div className="text-xs md:text-sm text-stone-600">Years Experience</div>
            </div>
          </div>
          
          <div>
            <div className="text-xs uppercase tracking-widest text-amber-700 mb-3 md:mb-4">About Me</div>
            <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4 md:mb-6 leading-tight">
              Creating Content That<br />
              <span className="font-light italic">Actually Converts</span>
            </h2>
            <p className="text-base md:text-lg text-stone-500 mb-4 md:mb-6 leading-relaxed">
              I'm Sarah, a full-time UGC creator based in Los Angeles. I specialize in creating 
              authentic, relatable content that helps brands connect with their audience and 
              drive real results.
            </p>
            <p className="text-base md:text-lg text-stone-500 mb-6 md:mb-8 leading-relaxed">
              My content has generated over <strong className="text-stone-900">2.5M+ views</strong> and 
              helped brands achieve up to <strong className="text-stone-900">3x ROAS</strong> on their ad campaigns.
            </p>
            
            <div className="flex flex-wrap gap-2 md:gap-3">
              {['Beauty', 'Skincare', 'Tech', 'Fashion', 'Lifestyle', 'Wellness'].map((niche, i) => (
                <span key={i} className="px-3 md:px-4 py-1.5 md:py-2 bg-stone-100 text-stone-700 rounded-full text-xs md:text-sm font-medium">
                  {niche}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Services */}
        <div className="text-center mb-8 md:mb-12">
          <div className="text-xs uppercase tracking-widest text-amber-700 mb-3 md:mb-4">What I Offer</div>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900">
            Services & <span className="font-light italic">Deliverables</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-stone-50 rounded-2xl md:rounded-3xl p-6 md:p-8 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer border border-stone-100"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 bg-amber-100 rounded-xl md:rounded-2xl flex items-center justify-center mb-4 md:mb-6">
                <i className={`${service.icon} text-xl md:text-2xl text-amber-700`}></i>
              </div>
              
              <h3 className="text-lg md:text-xl font-bold text-stone-900 mb-2 md:mb-3">{service.title}</h3>
              <p className="text-sm md:text-base text-stone-500 mb-4 md:mb-6 leading-relaxed">{service.description}</p>
              
              <div className="space-y-2">
                {service.deliverables.map((item, i) => (
                  <div key={i} className="flex items-center gap-2 text-xs md:text-sm text-stone-600">
                    <i className="ri-check-line text-green-600"></i>
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
